import { z } from 'zod';
import { AbilityNameSchema, SizeSchema, SourceSchema } from './common.schema';

const AbilityBonusSchema = z.object({
  ability: AbilityNameSchema,
  bonus: z.number(),
});

const AbilityBonusChoiceSchema = z.object({
  count: z.number(),
  amount: z.number(),
  from: z.array(AbilityNameSchema),
});

const SpellGrantSchema = z.object({
  spellId: z.string(),
  level: z.number(),
  usesPerRest: z.number().optional(),
  restType: z.enum(['short', 'long']).optional(),
});

const TraitSpellGrantsSchema = z.object({
  cantrips: z.array(z.string()),
  spells: z.array(SpellGrantSchema),
  spellcastingAbility: AbilityNameSchema,
});

const TraitSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  spellGrants: TraitSpellGrantsSchema.optional(),
});

const SubraceSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  abilityBonuses: z.array(AbilityBonusSchema),
  traits: z.array(TraitSchema),
});

export const RaceSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  abilityBonuses: z.array(AbilityBonusSchema),
  abilityBonusChoice: AbilityBonusChoiceSchema.optional(),
  age: z.string(),
  size: SizeSchema,
  sizeDescription: z.string(),
  speed: z.number(),
  speedTypes: z
    .object({
      fly: z.number().optional(),
      swim: z.number().optional(),
      climb: z.number().optional(),
      burrow: z.number().optional(),
    })
    .optional(),
  languages: z.array(z.string()),
  languageChoice: z.number().optional(),
  traits: z.array(TraitSchema),
  subraces: z.array(SubraceSchema).optional(),
  source: SourceSchema,
});

export type RaceData = z.infer<typeof RaceSchema>;
